module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB9SURBVHgBzVHBCYAwDEzEt3uIiziAIziWA7mAOIELZIF6AQNSK0YL6kGaNPQuR0P0NViPEMKMVO36guiYeXKpQGCJ7g1i1HzF5ZSAEwKHddKBB8YpKBPvCcByrxH3Sy8Zqd1qwucNtx2cweVAJ+pkqw8PctZoDuSBiNAvsAJ+cECeZzWngwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/addPro.png
// module id = weo9
// module chunks = 4